import { render, staticRenderFns } from "./Reddot.vue?vue&type=template&id=b70b0434&scoped=true&"
import script from "./Reddot.vue?vue&type=script&lang=js&"
export * from "./Reddot.vue?vue&type=script&lang=js&"
import style0 from "./Reddot.vue?vue&type=style&index=0&id=b70b0434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70b0434",
  null
  
)

export default component.exports